import { useEffect } from 'react'

interface ModalProps {
  onClose: () => void
  title: string
  children: React.ReactNode
  width?: string
}

export function Modal({ onClose, title, children, width = 'max-w-md' }: ModalProps) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className={`w-full ${width} bg-bg-primary rounded-2xl shadow-2xl flex flex-col max-h-[80vh]`}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-divider shrink-0">
          <h3 className="text-txt-primary font-semibold text-base">{title}</h3>
          <button
            onClick={onClose}
            className="text-txt-secondary hover:text-txt-primary transition-colors w-7 h-7 flex items-center justify-center rounded-lg hover:bg-bg-hover"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M18 6 6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}
